
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';
import SectionHeading from '@/components/ui/section-heading';

interface Benefit {
  id: number;
  title: string;
  description: string;
  icon: string;
}
// uses unicode format, you can look here https://arachnoid.com/unicode/ to find the relevant ones. Format is "'\u{...}'"
const benefits: Benefit[] = [
  {
    id: 1,
    title: 'Stealth Tech',
    description: 'No above-ground infrastructure. Completely invisible protection that preserves your landscape.',
    icon: '\u{1F51D}' //top with upwards arrow above
  }, 
  {
    id: 2,
    title: 'Low Maintenance',
    description: 'No physical fence wear, no moving parts, with minimal upkeep required.',
    icon: '\u{1F6E0}' //hammer and wrench
  }, 
  {
    id: 3,
    title: 'Custom Range',
    description: 'Scalability to cover fields, pipelines, or industrial complexes up to 100km+.',
    icon: '\u{1F4DD}' //memo
  }, 
  {
    id: 4,
    title: 'AI-Powered Accuracy',
    description: 'Distinguishes between animals, weather, vehicles, and human intrusions.',
    icon: '\u{1F9E0}' //brain
  }, 
  {
    id: 5,
    title: 'Invisible Barriers',
    description: 'Unseen barriers protect without sacrificing aesthetics, whether safeguarding your estate, property, boundary, or project.',
    icon: '\u{1F92B}'// face with finger covering closed lips
  }, 
  {
    id: 6,
    title: 'Enterprise-Ready Scale',
    description: 'Scale from small estates to 100km+ utility corridors with consistent performance.',
    icon: '\u{1F762}'//Alchemical Symbol For Dissolve-2
  }
];

const FibreBenefits = () => {
  return (
    <section aria-labelledby="benefits-heading" className="section bg-white py-[53px]">
      <div className="container mx-auto">
        <SectionHeading 
          title="Why Choose It?"
          className="text-center mb-8"
          titleClassName="text-forti-fi-teal"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <AnimateInView key={benefit.id} animation="scale-in" delay={100 * index}>
              <div className="bg-forti-fi-background p-6 rounded-lg border border-forti-fi-lavender/20 hover:shadow-md transition-shadow h-full bg-[#afffce]/[0.16]">
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-serif text-forti-fi-teal mb-2">{benefit.title}</h3>
                <p className="text-forti-fi-charcoal">{benefit.description}</p>
              </div>
            </AnimateInView>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FibreBenefits;
